import React from 'react';
import PropTypes from 'prop-types';
import { colorBorder, colorBackground, colorHover } from '@spark/ui-components/theme';
import { left } from '@spark/ui-components/theme';
import styled from 'styled-components';
import SidebarLink, { SidebarLinkTitle } from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { useMenu } from '@/context/MenuContext';
import ProtectedElement from '@spark/ui-components/components/ProtectedElement';

const SidebarContent = ({
  onClick,
  collapse
}) => {
  const {
    getAvailableMenus
  } = useMenu();
  const availableMenus = getAvailableMenus();
  return <SidebarContentWrap collapse={collapse}>
      <SidebarBlock collapse={collapse}>
        {availableMenus.map(menu => <ProtectedElement key={menu.id} requiredRights={menu.rights} showFallback={false}>
            {menu.submenus.length > 0 ? // Menu com submenus - usar SidebarCategory
        <SidebarCategory title={menu.title} icon={menu.icon} collapse={collapse}>
                {menu.submenus.map(submenu => <ProtectedElement key={submenu.id} requiredRights={submenu.rights} showFallback={false}>
                    <SidebarLink title={submenu.title} route={submenu.route} onClick={onClick} />
                  </ProtectedElement>)}
              </SidebarCategory> : // Menu direto - usar SidebarLink
        <SidebarLink title={menu.title} route={menu.route} onClick={onClick} icon={menu.icon} />}
          </ProtectedElement>)}
      </SidebarBlock>
    </SidebarContentWrap>;
};

SidebarContent.propTypes = {
  onClick: PropTypes.func.isRequired,
  collapse: PropTypes.bool
};
SidebarContent.defaultProps = {
  collapse: false
};
export default SidebarContent; // region STYLES

const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;
  
  & > div:last-child {
    width: 4px !important;

    div {
      transition: height 0.3s ease;
      opacity: 0.52;
    }
  }
  
  @media screen and (min-width: 576px) {
    padding-top: 0;
    
    ${props => props.collapse && `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s ease;
    `}
  }
`;
const SidebarBlock = styled.ul`
  padding: 5px 0;
  border-bottom: 1px solid ${colorBorder};
  list-style-type: none;
  
  &:last-child {
    border: none;
  }
  
  @media screen and (min-width: 576px) {
    
    ${props => props.collapse && `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        transition: width 0.3s ease;
        
        span:last-of-type {
          opacity: 0;
          transition: opacity 0.3s ease;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
          transition: opacity 0.3s ease;
        }
  
        &:hover {
          background: ${colorHover(props)};
          width: 275px;
          
          span:last-of-type {
            opacity: 1;
          }
          
          ${SidebarLinkTitle} {
            opacity: 1;
          }
        }
      }
    `}
  }
`; // endregion
